<template>
  <div class="telemetry-tire-temperature-section">
    <img
      class="telemetry-tire-temperature-section__car"
      src="assets/img/RaceVideoPage/telemetry/tire_car.svg"
      alt=""
      width="102"
      height="63"
    />

    <telemetry-tire-temperature-fl-parts v-model="tireTemperature.fl" :diffMs="diffMs" />
    <telemetry-tire-temperature-fr-parts v-model="tireTemperature.fr" :diffMs="diffMs" />
    <telemetry-tire-temperature-rl-parts v-model="tireTemperature.rl" :diffMs="diffMs" />
    <telemetry-tire-temperature-rr-parts v-model="tireTemperature.rr" :diffMs="diffMs" />

    <p class="telemetry-tire-temperature-section__label"><span>Tire temp.</span></p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import TelemetryTireTemperatureFlParts from '@/components/RaceVideoPage/RaceVideoDataViewPane/parts/TelemetryTireTemperatureFlParts.vue'
import TelemetryTireTemperatureFrParts from '@/components/RaceVideoPage/RaceVideoDataViewPane/parts/TelemetryTireTemperatureFrParts.vue'
import TelemetryTireTemperatureRlParts from '@/components/RaceVideoPage/RaceVideoDataViewPane/parts/TelemetryTireTemperatureRlParts.vue'
import TelemetryTireTemperatureRrParts from '@/components/RaceVideoPage/RaceVideoDataViewPane/parts/TelemetryTireTemperatureRrParts.vue'

/**
 * レース動画再生画面 テレメトリー タイヤ温度値セクションのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryTireTemperatureSection',
  components: {
    TelemetryTireTemperatureFlParts,
    TelemetryTireTemperatureFrParts,
    TelemetryTireTemperatureRlParts,
    TelemetryTireTemperatureRrParts,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    diffMs: {
      type: Number,
      required: true,
    },
  },
  methods: {},
  setup(props) {
    const tireTemperature = computed(() => props.value)
    return {
      tireTemperature,
    }
  },
})
</script>

<style lang="scss" scoped>
.telemetry-tire-temperature-section {
  position: absolute;
  left: min(4.2667vw, 1.333em);
  right: min(4.2667vw, 1.333em);
  top: calc(#{min(4.2667vw, 1.333em)} + 29.25em);
  height: 11.4em;

  &__car {
    position: absolute;
    left: 50%;
    top: 16%;
    width: 8.5em;
    height: 5.25em;
    transform: translateX(-50%);
    z-index: 2;
  }

  &__label {
    position: absolute;
    top: calc(72.4% - (var(--safe-area-inset-bottom) / 3));
    width: 100%;
    text-align: center;
    font-size: 1em;
    font-weight: 500;
    letter-spacing: 0.1em;
    padding-left: 0.2em;
    color: #fff;
    opacity: 0.8;

    span {
      font-size: max(1em, 8px);
    }
  }
}
</style>

<style lang="scss">
.telemetry-tire-temperature-section {
  &__tire_temperature {
    color: $white;
    background: rgba(255, 255, 255, 0.2);

    &--cold {
      color: $blue-light;
      background: rgba(0, 56, 255, 0.2);
    }

    &--normal {
      color: $green-light;
      background: rgba(0, 219, 166, 0.2);
    }

    &--hot {
      color: $red-light;
      background: rgba(255, 46, 0, 0.2);
    }
  }
}

.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-tire-temperature-section {
      top: calc(#{min(4.2667vw, 1.333em)} + 31.25em);

      &__car {
        top: 10%;
      }

      &__label {
        top: 62%;

        span {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
